// firebase.js — versione con FCM (notifiche push)
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getMessaging, isSupported } from "firebase/messaging";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyBBQFBvrF_jQQh0biQjN6akNhwMA1PctTI",
  authDomain: "trucky-96c2f.firebaseapp.com",
  projectId: "trucky-96c2f",
  storageBucket: "trucky-96c2f.firebasestorage.app",
  messagingSenderId: "355653125503",
  appId: "1:355653125503:web:0dc20d76634b1273f9c64a",
  measurementId: "G-BNB04PXF2D",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const functionsInstance = getFunctions(app);

// Messaging solo se supportato dal browser
export const messaging = (async () => {
  const supported = await isSupported();
  return supported ? getMessaging(app) : null;
})();
